import { addChannelMember, applyMemberEvents, removeInvitationsByUserIds, setUserInfoArr } from '../../../slice';
import { Store } from '../../../store';
import { fetchInvitationCount } from '../services';
import logger from '../../../Helpers/logger';

export const handleAddMemberInChannel = data => {
    try {
        const { participants } = data || {};

        const settings = data?.settings || data.channel.settings;
        const restructured = {
            ...data.channel,
            ...(settings && { settings }),
        };
        const memberEvents = participants.map(member => ({
            type: 'ADD',
            member,
        }));
        Store.dispatch(setUserInfoArr(participants));
        Store.dispatch(applyMemberEvents({ channelId: restructured.channelId, memberEvents }));
        Store.dispatch(
            addChannelMember({
                channel: restructured,
                participants,
            }),
        );
        const participantIds = Array.isArray(participants) ? participants.map(m => m?.userId).filter(Boolean) : [];
        if (participantIds.length) {
            Store.dispatch(
                removeInvitationsByUserIds({
                    channelId: restructured.channelId,
                    userIds: participantIds,
                }),
            );
        }
        fetchInvitationCount();
    } catch (error) {
        logger.debug('failed to added member in channel', error);
    }
};
